import * as THREE from 'three';
import {
  ModelDrawer
} from "@/drawings3D/modelDrawing/ModelDrawer"

import {
  CARD1Web, MouseAction
} from '@/drawings3D/CoordUtils.js';


import {CSS2DRenderer, CSS2DObject} from './thirdparty/utils/CSS2DRenderer.js'
import {CSS2DRenderer1, CSS2DObject1} from './thirdparty/utils/CSS2DRenderer1.js'


export class GeometryObject {
  constructor(name, uuid, mesh, drawer) {
    this.name = name;
    this.uuid = uuid;
    this.mesh = mesh;
    this.drawer = drawer;

  }
}


//管理所有的可以选中的三维对象
export class GeometryManager {
  constructor(sceneManager) {
    this.sceneManager = sceneManager;
    this.geometryMap = new Object();
    this.meshContainerMap = new Object();
    this.geometryContainer = new Array();
    //由于模型可以切换显示和隐藏，增加这一项用于点击交互不到那些隐藏的model;
    this.currentGeometryContainer = new Array();
    // 用于存放地基模型，用于求模型落在地基的位置
    this.groundContainer = new Array();
    this.sceneManager.geometryManager = this;
    
    //用于存放轨迹模型
    this.locusContainer = new Array();

    this.sceneLeft = $('#WebGL-output').offset().left;
    this.sceneTop = $('#WebGL-output').offset().top;
    this.sceneWidth = $('#WebGL-output').width();
    this.sceneHeight = $('#WebGL-output').height();
    this.sosObjs=[];//用于装需要显示sos状态的mesh
  }

  //添加一条道路
  addRoad(road) {
    var roadObject = new GeometryObject(road.name, road.mesh.uuid, road.mesh, road);
    this.geometryContainer.push(road.mesh);
    this.currentGeometryContainer.push(road.mesh);
    this.groundContainer.push(road.mesh);
    this.geometryMap[road.mesh.uuid] = roadObject;
    // this.roadsMap[road.name] = road;
    if (road.roadId ==1){
      this.mainRoad = road; 
    }
  }

  getMainRoad(){
    return this.mainRoad;
  }
  getRoadByName(roadName){
    return this.geometryMap[roadname];
  }

  addEarth(earthModel){
    this.geometryContainer.push(earthModel);
  }
  addModel(modelInfo, modelMesh){
    // console.log('modelMesh',modelMesh)
    var meshObject = new GeometryObject(modelInfo.info, modelMesh.uuid, modelMesh);
    this.geometryContainer.push(modelMesh);
    this.currentGeometryContainer.push(modelMesh);
    this.geometryMap[modelMesh.uuid] = meshObject;
    modelMesh.ownerDrawer = new ModelDrawer(modelMesh, this.sceneManager);
    // console.log('modelMesh',modelMesh)
    this.sceneManager.scene.add(modelMesh);
    //目前无法得到所有模型加载完的时机，故在此处理工人sos状态
    if(modelInfo.info&&(modelInfo.info.type=='person'&&modelInfo.info.sos)){
         this.sosObjs.push(modelMesh);
         this.sceneManager.outlinePass.selectedObjects = this.sosObjs;
         let vector3=this.getMaxYFromModel(modelMesh,1);
         this.sosSprite(vector3,modelInfo.info);
         // this.sceneManager.webView.tipsSosSync(modelMesh.uuid,modelInfo.info.name)
    }
    return modelMesh;
  }

  addMeshObject(id, meshObj){
    this.meshContainerMap[id] = meshObj;
     // this.geometryContainer.push(meshObj);
     this.sceneManager.scene.add(meshObj);
  }
  // 路面地面存放容器
  addGroundObject(meshObj){
      this.groundContainer.push(meshObj);
  }
  getMeshObject(id){
    return this.meshContainerMap[id];
  }
  
  removeMeshObject(id){
    // console.log("scene children before:"  + this.sceneManager.scene.children.length);
    var obj = this.meshContainerMap[id];
    if (obj){
       this.sceneManager.scene.remove(obj);
    }
    // console.log("scene children before:"  + this.sceneManager.scene.children.length);
  }

  deleteModel(model){
    this.geometryContainer.forEach((item,index)=>{
        if(item==model){
            this.geometryContainer.splice(index,1);  
        }
    })
    this.currentGeometryContainer.forEach((item,index)=>{
        if(item==model){
            this.currentGeometryContainer.splice(index,1);
        }
    })
    // this.geometryContainer.remove(model);
    this.geometryMap[model.uuid] = null;
    delete this.geometryMap[model.uuid];
    this.sceneManager.scene.remove(model);
  }

  rotateModel(model, rotAngle){
    model.rotateY(rotAngle);
  }
  scaleModel(model, ratio){
    model.scale.set(ratio, ratio, ratio);
  }
  hideMoshes(model){
     this.currentGeometryContainer.forEach((oitem,oindex)=>{
        if(oitem==model){
            this.currentGeometryContainer.splice(oindex,1);
        }
     })
     this.sceneManager.scene.remove(model);
  }
  getMeshes(){
      return this.geometryContainer;
  }
  getTargetMeshes(){
      return this.currentGeometryContainer;
  }

  //管理模型的轨迹
  removeLocusMesh(){
    this.locusContainer.forEach((item,index)=>{
        this.sceneManager.scene.remove(item);
    })
    this.locusContainer=[];
  }
  addLocusMesh(mesh){
    this.locusContainer.push(mesh);
    this.sceneManager.scene.add(mesh);
  }
  // 获取可以交互的mesh,本来是想把sos的人物模型和头上的sos图标做成一个group,但是也有其他问题,getTargetMeshes
  // 用于切换当前的显示和隐藏模型，getInteractiveMeshes剔除一些显示的不可交互模型，如sos人物头上的sos图标
  getInteractiveMeshes(){
     var meshes=[];
     // currentGeometryContainer
     this.currentGeometryContainer.forEach((item,index)=>{
         if(!item.oInfo||(item.oInfo&&!item.oInfo.notInteractive)){
             meshes.push(item); 
         }
     })
     return meshes;
  }
  getGroundMeshes(){
     return this.groundContainer;
  }
  helpModelPosition(lon,lat){
      // 从一个无限高向低发送射线
      var x =lat - this.sceneManager.CoordOffset.lat;
      var z =lon - this.sceneManager.CoordOffset.lon;
      var position = new THREE.Vector3(x,8000,z);
      var position2 = new THREE.Vector3(x,-8000,z);
      var raycaster = new THREE.Raycaster(position,position2.sub(position).normalize());
      var intersects = raycaster.intersectObjects(this.getGroundMeshes(),true);
      if(intersects[0]&&intersects[0].point){
          // 加一个0.5的Y方向的偏移，防止脚在地形里
          var point = intersects[0].point;
          point.setY(point.y+0.5)
          return point;
      }else{
          // 与地形没交点的给我一个大致值1922
          return new THREE.Vector3(x,1922,z);
      }
  }
  //当前鼠标相对位置对应的三维可选坐标, action指是什么行为比如选中或者鼠标悬停
  getSelectMesh(x, y, action, web3DVue) {
    // console.log(x,y)
    var vector = new THREE.Vector3(((x - this.sceneLeft) / this.sceneWidth) * 2 - 1, -((y - this.sceneTop) / this.sceneHeight) * 2 + 1, 0.5);
    //注意：二维坐标在这里是无法转换成准确的三维坐标的，因为z的不同，是不一样的，只能和相机一起向某个方向发射射线判断交点
    vector = vector.unproject(this.sceneManager.camera.get());
    var raycaster = new THREE.Raycaster(this.sceneManager.camera.get().position, vector.sub(this.sceneManager.camera.get().position).normalize());
    // getInteractiveMeshes
    // getGroundMeshes
    var intersects = raycaster.intersectObjects(this.getInteractiveMeshes(), true);

    //手点获取坐标添加模型
    // if(action.mouse==0){
    //   var lon=intersects[0].point.z+this.sceneManager.CoordOffset.lon;
    //   var lat=intersects[0].point.x+this.sceneManager.CoordOffset.lat;
    //   console.log(lon,lat)
    // }

    web3DVue.curCoordDesc = "";
    if (intersects.length > 0) {
      var geometry = intersects[0].object.geometry;
      var faceIndex = "";
      if(intersects[0].face&&intersects[0].face.a){
          faceIndex =  intersects[0].face.a; 
      }
      geometry.ownerDrawer.doSelect(intersects[0], action, web3DVue);
      if(this.currentSelectedGeometry && this.currentSelectedGeometry != geometry && this.currentSelectedGeometry.ownerDrawer && this.currentSelectedGeometry.ownerDrawer.changeToUnSelectedColor){
           if(this.sceneManager.pointLabel){
               this.removeModelTips();
           }
           if(!this.currentSelectedGeometry.ownerDrawer.model.openPanel){
               if(this.currentSelectedGeometry.ownerDrawer.model.oSelect){
                     this.sceneManager.outlinePassGreen.selectedObjects=[];                
               }else{
                    this.currentSelectedGeometry.ownerDrawer.changeToUnSelectedColor();
               }
           }
      }else{
          if(this.targetModel&&!this.targetModel.openPanel){
              if(this.targetModel.oSelect){
                     this.sceneManager.outlinePassGreen.selectedObjects=[];                
               }else{
                    this.targetModel.ownerDrawer.changeToUnSelectedColor();
               }
               this.targetModel=null
          }
      }
      this.currentSelectedGeometry = geometry;    
      return;
    }
    else{
      if(this.sceneManager.pointLabel){
          this.removeModelTips();
      }
      if(this.currentSelectedGeometry && this.currentSelectedGeometry.ownerDrawer && this.currentSelectedGeometry.ownerDrawer.changeToUnSelectedColor){
          if(!this.currentSelectedGeometry.ownerDrawer.model.openPanel){
            if(this.currentSelectedGeometry.ownerDrawer.model.oSelect){
                  this.sceneManager.outlinePassGreen.selectedObjects=[];              
             }else{
                  this.currentSelectedGeometry.ownerDrawer.changeToUnSelectedColor();
             } 
          }
      }else{
          if(this.targetModel&&!this.targetModel.openPanel){
              if(this.targetModel.oSelect){
                     this.sceneManager.outlinePassGreen.selectedObjects=[];                
               }else{
                    this.targetModel.ownerDrawer.changeToUnSelectedColor();
               }
               this.targetModel=null
          }
      }
      this.currentSelectedGeometry = null;
    }
    
  }
  //显示sos精灵图片
  sosSprite1(vector3,info){
      var spriteWidth = 0.7,
          spriteHeight = 0.7;
      var spriteMap = new THREE.TextureLoader().load( "/static/bimroad/textures/sos.png" );
      // spriteMap.needsUpdate = true;
      // var spriteMaterial = new THREE.SpriteMaterial( { map: new THREE.CanvasTexture(this.getTextCanvas('SOS')),color:'#ffffff'  } );
      // console.log('caizhi',spriteMaterial)
      var spriteMaterial = new THREE.SpriteMaterial( { map: spriteMap ,color:'#ffffff'  } );
      // spriteMaterial.map.needsUpdate = true;
      var sprite = new THREE.Sprite( spriteMaterial );
      sprite.scale.x = spriteWidth;
      sprite.scale.y = spriteHeight;
      sprite.position.copy(vector3);
      //不能交互
      var oInfo={notInteractive:true};
      sprite.oInfo={...oInfo,...info};
      this.geometryContainer.push(sprite);
      this.currentGeometryContainer.push(sprite);
      this.sceneManager.scene.add( sprite );
  }
  sosSprite(vector3,info){
      var spriteWidth = 0.7,
          spriteHeight = 0.7;
      var video = document.getElementById('video');
      var texture = new THREE.VideoTexture(video);
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.format = THREE.RGBFormat;
      // spriteMap.needsUpdate = true;
      // var spriteMaterial = new THREE.SpriteMaterial( { map: new THREE.CanvasTexture(this.getTextCanvas('SOS')),color:'#ffffff'  } );
      // console.log('caizhi',spriteMaterial)
      var spriteMaterial = new THREE.SpriteMaterial( { map: texture ,color:'#ffffff'  } );
      // spriteMaterial.map.needsUpdate = true;
      var sprite = new THREE.Sprite( spriteMaterial );
      sprite.scale.x = spriteWidth;
      sprite.scale.y = spriteHeight;
      sprite.position.copy(vector3);
      //不能交互
      var oInfo={notInteractive:true};
      sprite.oInfo={...oInfo,...info};
      this.geometryContainer.push(sprite);
      this.currentGeometryContainer.push(sprite);
      this.sceneManager.scene.add( sprite );
  }
  //得到模型的高度
  getMaxYFromModel(mesh,type){ 
       // 1      整个高
       // 2      半个高
       mesh.children[0].geometry.computeBoundingBox();
       var disY=mesh.children[0].geometry.boundingBox.max.y-mesh.children[0].geometry.boundingBox.min.y;
       var disX=mesh.children[0].geometry.boundingBox.max.x-mesh.children[0].geometry.boundingBox.min.x;
       var position=new THREE.Vector3();
       if(type==1){
           position.copy(mesh.position);
           position.y+=disY+0.5;
       }else if(type==2){
           position.copy(mesh.position);
           position.y+=disY/2+0.5;
       }
       return position
  }
  //弹窗展示css2D
  showModelTips(mesh,text){
    //算出模型中心右点3D坐标
    var position=new THREE.Vector3();
    position=this.getModelTipsPosition(mesh);
    var dom = document.createElement('div');
    // dom.className='modelTips';
    dom.style.cssText="padding:0 10px;height:30px;border-radius:4px;line-height:30px;font-size:12px;color:#fff;text-align: center;background-color:#253924;";
    dom.textContent=text;
    this.sceneManager.pointLabel = new CSS2DObject(dom);   
    this.sceneManager.pointLabel.position.set(position.x, position.y,position.z);    
    this.sceneManager.scene.add(this.sceneManager.pointLabel);
    this.sceneManager.labelRenderer = new CSS2DRenderer(); //新建CSS2DRenderer 
    this.sceneManager.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    this.sceneManager.labelRenderer.domElement.style.position = 'absolute';
    this.sceneManager.labelRenderer.domElement.style.top = 0;
    document.getElementById('WebGL-output').appendChild(this.sceneManager.labelRenderer.domElement);
  }

  removeModelTips(){
       var dom= this.sceneManager.pointLabel;
       this.sceneManager.scene.remove(dom);
       this.sceneManager.pointLabel=null;
       document.getElementById('WebGL-output').removeChild(this.sceneManager.labelRenderer.domElement);
  }

  showInfoPanel(mesh,dom){
      //算出模型中心右点3D坐标
    var vector3=new THREE.Vector3();
    if(!mesh.children.length){
       vector3.copy(mesh.position);
       vector3.y+=1;
    }else{
       vector3=this.getMaxYFromModel(mesh,1);
    }
    this.choosePosition=vector3;
    this.sceneManager.pointPanel = new CSS2DObject1(dom); 
     return this.getMatrix4Position();  
    // this.sceneManager.pointPanel.position.set(vector3.x, vector3.y,vector3.z);    
    // this.sceneManager.scene.add(this.sceneManager.pointPanel);
    // this.sceneManager.panelRenderer = new CSS2DRenderer1(); //新建CSS2DRenderer 
  }
  addInfoPanel(){
    if(this.sceneManager.pointPanel&&!this.sceneManager.panelRenderer){
        var vector3=this.choosePosition;
        this.sceneManager.pointPanel.position.set(vector3.x, vector3.y,vector3.z);    
        this.sceneManager.scene.add(this.sceneManager.pointPanel);
        this.sceneManager.panelRenderer = new CSS2DRenderer1(); //新建CSS2DRenderer
        // 这里用于创建遮盖层
        // this.sceneManager.panelRenderer.setSize(window.innerWidth, window.innerHeight);
        // document.getElementById('app').appendChild(this.sceneManager.panelRenderer.domElement);
    }
  }
  getMatrix4Position(){
    var _widthHalf=window.innerWidth/2;
    var _heightHalf=window.innerHeight/2;
    var viewProjectionMatrix = new THREE.Matrix4();
    var viewMatrix = new THREE.Matrix4();
    var vector = new THREE.Vector3();
    viewMatrix.copy(this.sceneManager.activeCamera.camera.matrixWorldInverse );
    viewProjectionMatrix.multiplyMatrices( this.sceneManager.activeCamera.camera.projectionMatrix, viewMatrix );
    vector.copy(this.choosePosition);
    vector.applyMatrix4( viewProjectionMatrix );
    var style = 'translate(20%,-50%) translate(' + ( vector.x * _widthHalf + _widthHalf ) + 'px,' + ( - vector.y * _heightHalf + _heightHalf ) + 'px)';
    return style;    
  }

  testModelPanel(mesh){
    var vector2=this.getModelPanelPosition(mesh);
  }
  getModelTipsPosition(mesh){
      var disY;
      var disX;
      if(mesh.children.length>0){
          mesh.children[0].geometry.computeBoundingBox();
          disY=mesh.children[0].geometry.boundingBox.max.y-mesh.children[0].geometry.boundingBox.min.y;
          disX=mesh.children[0].geometry.boundingBox.max.x-mesh.children[0].geometry.boundingBox.min.x;
      }else{
          mesh.geometry.computeBoundingBox();
          disY=mesh.geometry.boundingBox.max.y-mesh.geometry.boundingBox.min.y;
          disX=mesh.geometry.boundingBox.max.x-mesh.geometry.boundingBox.min.x;
      }
     var position=new THREE.Vector3();
     position.copy(mesh.position);
     position.x-=(disX/2+0.5);
     position.y+=disY;
     return position;
  }
  getModelPanelPosition(mesh){
      var disY;
      var disX;
      if(mesh.children.length>0){
          mesh.children[0].geometry.computeBoundingBox();
          disY=mesh.children[0].geometry.boundingBox.max.y-mesh.children[0].geometry.boundingBox.min.y;
          disX=mesh.children[0].geometry.boundingBox.max.x-mesh.children[0].geometry.boundingBox.min.x;
      }else{
          mesh.geometry.computeBoundingBox();
          disY=mesh.geometry.boundingBox.max.y-mesh.geometry.boundingBox.min.y;
          disX=mesh.geometry.boundingBox.max.x-mesh.geometry.boundingBox.min.x;
      }
     var position=new THREE.Vector3();
     position.copy(mesh.position);
     position.x-=(disX/2+0.5);
     position.y+=(disY+0.5);
     // return position
     return this.sceneManager.getScreenPos(position);
        
  }
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/GeometryManager.js